import styled from "styled-components";
import { fadeIn } from "../../../components/Common/CommonStyles";

export const DashboardStyles = {
  homeButtonWidth: "auto",
  homeButtonHeight: "50px",
};

export const DashboardButtonsContainer = styled.div`
  flex: 1;
  display: flex;
  max-width: ${({ maxWidth }) => maxWidth || "950px"};
  @media screen and (max-width: 844px) {
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const DisclaimerContainer = styled.div`
  flex: 1;
  flex-direction: column;
  border: 2px solid ${(props) => props.colorBorder || "black"};
  padding: 8px;
  border-radius: 12px;
  max-width: ${({ maxWidth }) => maxWidth || "950px"};
  @media screen and (max-width: 844px) {
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const ModalOptionsButtonsContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  max-width: ${({ maxWidth }) => maxWidth || "950px"};
  @media screen and (max-width: 844px) {
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const HospMenuWrapper = styled.div`
  position: relative;
`;

export const HospSubmenu = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  background: #ffffff;
  padding: 10px;
  border-radius: 6px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  z-index: 10;
  min-width: ${DashboardStyles.homeButtonWidth};
  cursor: pointer;
  font-weight: bold;
`;

export const EgresosModalContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  text-align: center;
  padding: 10px 5px;
`;

export const EgresosModalTitle = styled.h3`
  margin-bottom: 10px;
  font-weight: bold;
  color: #333;
`;

export const EgresosModalText = styled.p`
  color: #555;
  margin-bottom: 20px;
`;
